import { memo, useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import { useInView } from "react-intersection-observer";
import ImageSingle from "./ImageSingle";
import { getPropertyImages } from "@/api/srp";
import { setSelectedProperty } from "@/redux/SRP/srpSlice";
import { useDispatch } from "react-redux";
import { trackButtonClick } from "@/utils/analytics";
import { getSrpLocationLabel } from "@/utils/filterTrackingService";
import { getPropertyURL } from "@/utils/propertyNavigation";

const ImageCarousel = ({
  item,
  isRecommendedProperties,
  onClick,
  enableNavigation = true,
  isMapCard = false,
}) => {
  const [index, setIndex] = useState(1);
  const [imageList, setImageList] = useState([{ pdpBigImage: item?.imageUrl }]);
  const dispatch = useDispatch();
  const { ref, inView: shouldFetchImg } = useInView({
    threshold: 0.1,
  });

  const handleSelect = (selectedIndex) => {
    setIndex(parseInt(selectedIndex) + 1);

    const newIndex = parseInt(selectedIndex) + 1;
    const direction = newIndex > index ? "next" : "prev";
    const location = getSrpLocationLabel();


    const eventLabel = `Scroll ${direction} to: ${newIndex} | Photo count: ${
      imageList?.length
    } | Property id: ${
      item?.propertyId
    } |  Listing id: ${
      item?.listingId
    } | Location: ${location}`;

    trackButtonClick({
      pageName: 'image_carousel_scroll',
      eventCategory: "NEW-SRP",
      eventLabel,
      eventSource: `carousel_${direction}_click`,
    });
  };

  const getCardImages = async (propertyId) => {
    try {
      const propertyImages = await getPropertyImages(propertyId);
      if (propertyImages) {
        setImageList(propertyImages);
      } else {
        setImageList([
          ...imageList,
          ...Array.from(Array(parseInt(item?.photoCount) - 1).keys()).map(
            (i) => ({ pdpBigImage: item?.imageUrl })
          ),
        ]);
      }
    } catch (error) {
      console.error("Error fetching Images", error);
    }
  };

  // useEffect(() => {
  //   if (item?.propertyId && item?.photoCount && parseInt(item?.photoCount) > 1) {
  //     getCardImages(item?.propertyId);
  //   }
  // }, [item?.propertyId]);

  useEffect(() => {
    if (
      shouldFetchImg &&
      item?.propertyId &&
      item?.photoCount &&
      parseInt(item?.photoCount) > 1 &&
      imageList?.length <= 1
    ) {
      getCardImages(item?.propertyId);
    }
  }, [shouldFetchImg, item?.propertyId]);

  // const {imageList} = item;
  // const imageList = ["https://s3.amazonaws.com/hubzu-core-images-dev/2018/3/87929317520641448/87929317520641448_20180329082251868_1.JPEG.X278.Y184.JPEG",
  //   "https://s3.amazonaws.com/hubzu-core-images-dev/2017/10/0004320/0004320_20171026024152980_1.JPEG.X278.Y184.JPEG"];

  return (
    <div ref={ref}>
      {!isMapCard && imageList?.length > 0 ? (
        <Carousel
          controls={imageList?.length > 1 ? true : false}
          slide={false}
          indicators={false}
          interval={null}
          onSelect={handleSelect}
        >
          {imageList.map((imgItem, index) => {
            return (
              <Carousel.Item
                key={`SRP-gallery-${index}-${imgItem?.pdpBigImage}`}
                href={
                  enableNavigation && getPropertyURL(item?.listingUrl || `/property/${item?.listingId || item?.propertyId}`, item?.category, item?.propertyStatus)
                }
              >
                <ImageSingle
                  imageUrl={imgItem?.pdpBigImage}
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: isMapCard
                      ? 120
                      : isRecommendedProperties
                      ? 140
                      : 240,
                    transition: "0.4s ease-in-out",
                    minHeight: isMapCard
                      ? 120
                      : isRecommendedProperties
                      ? 140
                      : 240,
                  }}
                  href={
                    enableNavigation && getPropertyURL(item?.listingUrl || `/property/${item?.listingId || item?.propertyId}`, item?.category, item?.propertyStatus)
                  }
                  onClick={onClick}
                  onMouseOver={() =>
                    dispatch(setSelectedProperty({ ...item, scrollTo: false }))
                  }
                  onMouseOut={() =>
                    !isMapCard && dispatch(setSelectedProperty(null))
                  }
                />
              </Carousel.Item>
            );
          })}
        </Carousel>
      ) : (
        <ImageSingle
          imageUrl={item?.imageUrl}
          style={{
            objectFit: "cover",
            width: "100%",
            height: isMapCard ? 120 : isRecommendedProperties ? 140 : 220,
            transition: "0.4s ease-in-out",
            minHeight: isMapCard ? 130 : isRecommendedProperties ? 140 : 220,
          }}
          href={enableNavigation && getPropertyURL(item?.listingUrl || `/property/${item?.listingId || item?.propertyId}`, item?.category, item?.propertyStatus)}
          onClick={onClick}
          onMouseOver={() =>
            dispatch(setSelectedProperty({ ...item, scrollTo: false }))
          }
          onMouseOut={() => !isMapCard && dispatch(setSelectedProperty(null))}
        />
      )}
      {!isMapCard && imageList?.length > 1 && (
        <div className="row photo-count">
          <span>{`${index}/${imageList?.length}`}</span>
        </div>
      )}
    </div>
  );
};

export default memo(ImageCarousel);
